import { secondsToMilliseconds } from './seconds-to-milliseconds'

export function minutesToMilliseconds(minutes: number): number {
  return secondsToMilliseconds(minutes * 60)
}
